import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "./-assets/placeholder-settings.png";

export const Route = createFileRoute(
  "/_staff/ids/_layout/_placeholders/settings",
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
